//IDs de cada seccion en el Home de scroll a scroll
export const SectionIds = ["inicio", "nosotros", "servicios", "artistas", "contacto"];
